import * as React from 'react';
import OrderHistoryListingHeader from "./OrderHistory/OrderHistoryListing/OrderHistoryListingHeader/OrderHistoryListingHeader"
import OrderHistoryListing from './OrderHistory/OrderHistoryListing/OrderHistoryListing';

const OrderHistory = () => {
    return (
        <>
            <div id="main" className="order-history-page">
                <div className="container-fluid maxw100">
                    <OrderHistoryListingHeader />
                    <OrderHistoryListing />
                </div>
            </div>
        </>
    );
}

export default OrderHistory;